import React from 'react';
import InnerBaneer from './innerBanner';

const IndustriesComponent = ({ content }) => {
    return (
        <div className='industries-pg'>
            {/* inner-banner section start */ }
            {/* <div className="innerBaneer">
                <div className="container">
                    <div className="row-wrap">
                        <div className="box-12 box-md-6 img-box">
                            <div className="customAnim slide-right is-animate">
                                <div className="inner-box">
                                    <figure>
                                        <img src={ `${process.env.PUBLIC_URL}/images/illustrations/industries_cover.svg` } alt="animated" />
                                    </figure>
                                </div>
                            </div>
                        </div>
                        <div className="box-12 box-md-6 content-box">
                            <div className="customAnim slide-left is-animate">
                                <div className="inner-box">
                                    <div className="intro-box p-18">
                                        <h1 className="heading has-line">You – At the Forefront</h1>
                                        <p>We understand that every business has different financial needs, which is why we took the time to tailor our payments solutions to meet the needs of businesses in different industries. We can also customise our solutions to suit the needs of your business upon request.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}
            <InnerBaneer
                banner_cta_button={ content && content.banner_cta_button }
                banner_image={ content && content.banner_image }
                banner_info={ content && content.banner_info }
                banner_title={ content && content.banner_title }
            />
            {/* inner-banner section end */ }

            {/* infocontent section start */ }
            <div className="infocontent-box">
                <div className="container">
                    <div className="row-wrap">
                        <div className="box-12 content-box">
                            <div className="inner-box">
                                <div className="equal-space intro-box text-center">
                                    { content && content.section_title &&
                                        <h2>{ content.section_title }</h2>
                                    }
                                    <div dangerouslySetInnerHTML={ { __html: content && content.however_content_section[0].content } }></div>
                                </div>
                                {
                                    content && content.however_content_section && content.however_content_section.map((obj, index) => {
                                        return (
                                            <React.Fragment key={ index }>
                                                {
                                                    obj.is_add_partition_before_content &&
                                                    <div className="divider-box" style={ { 'height': '3px' } }>
                                                        <span className="line"></span>
                                                    </div>
                                                }
                                                {
                                                    obj.content_type === "two_column" && <div className="equal-space crossList two-column-list" dangerouslySetInnerHTML={ { __html: obj.content } }>
                                                    </div>
                                                }
                                                {
                                                    obj.content_type === "inline_content" && <div className="equal-space crossList inline-list" dangerouslySetInnerHTML={ { __html: obj.content } }>

                                                    </div>
                                                }
                                                {
                                                    index !== 0 && obj.content_type === "one_column" && <div className="equal-space intro-box text-center" dangerouslySetInnerHTML={ { __html: obj.content } }>
                                                    </div>
                                                }
                                            </React.Fragment>
                                        );
                                    })
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* infocontent section end */ }
        </div>
    );
};

const dummyContent = props => {
    return <>
        {/* intro box start */ }
        <div className="equal-space intro-box text-center">
            <h2>However,</h2>
            <p>if your business is involved in the following activities,<br></br> we will not be able to serve you:</p>
        </div>
        {/* intro box end */ }

        {/* two column list start  */ }
        <div className="equal-space crossList two-column-list">
            <ul>
                <li>Arms / Defence / Military</li>
                <li>Controlled substances</li>
                <li>Adult Services</li>
                <li>Counterfeit goods</li>
                <li>Digital currency / Non-fiat currency</li>
            </ul>
            <ul>
                <li>Arms / Defence / Military</li>
                <li>Controlled substances</li>
                <li>Adult Services</li>
                <li>Counterfeit goods</li>
                <li>Digital currency / Non-fiat currency</li>
            </ul>
        </div>
        {/* two column list end */ }

        {/* intro content start */ }
        <div className="equal-space intro-box text-center">
            <p>Other businesses usually evaluated as high-risk will be assessed on a case by case basis and the decision <br></br> to onboard any company will depend on Demivolt's risk appetite.</p>
        </div>
        {/* intro content end */ }

        {/* divider start  */ }
        <div className="divider-box" style={ { 'height': '3px' } }>
            <span className="line"></span>
        </div>
        {/* divider end */ }

        {/* intro content start */ }
        <div className="equal-space intro-box text-center">
            <p>Following high industry standards, regulatory obligations, and internal decisions, we will not establish<br></br> any business relationship with the clients from the following countries:</p>
        </div>
        {/* intro content end */ }

        {/* two column list start  */ }
        <div className="equal-space crossList two-column-list">
            <ul>
                <li>Afghanistan</li>
                <li>Bosnia & Herzegovina</li>
                <li>Ethiopia</li>
                <li>Guyana</li>
            </ul>

            <ul>
                <li>Iran</li>
                <li>Iraq</li>
                <li>Democratic People's Republic of Korea (DPRK)</li>
                <li>Syria</li>
            </ul>
        </div>
        {/* two column list end */ }

        {/* divider start  */ }
        <div className="divider-box" style={ { 'height': '3px' } }>
            <span className="line"></span>
        </div>
        {/* divider end */ }

        {/* intro content start */ }
        <div className="equal-space intro-box text-center">
            <p>Due to international Sanctions, Demivolt will not be able to execute your <br></br> payments from or to:</p>
        </div>
        {/* intro content end */ }

        {/* inline list start  */ }
        <div className="equal-space crossList inline-list">
            <ul>
                <li>Iran</li>
                <li>Syria</li>
                <li>Democratic People's Republic of Korea (DPRK)</li>
                <li>Crimea, Sevastopol</li>
            </ul>
        </div>
        {/* inline column list end */ }
    </>;
};

export default IndustriesComponent;